import { Group, HoverCard, Text, ThemeIcon } from "@mantine/core";
import { IconCircleCheckFilled, IconCircleFilled, IconCircleXFilled } from "@tabler/icons-react";
import { convertToDateTimeString } from "../../helpers/dates";
import type { DocumentViewStatus } from "../../models/documentViewStatus";

type DocumentViewStatusIndicatorProps = {
  documentViewStatus: DocumentViewStatus;
  sign: boolean;
  read: boolean;
  flex: number;
  disabled?: boolean;
};

export function DocumentViewStatusIndicator({ documentViewStatus, sign, read, flex, disabled = false }: DocumentViewStatusIndicatorProps) {
  let readText = disabled ? "Ist nicht definiert" : "Muss nicht angeschaut werden";
  let signText = disabled ? "Ist nicht definiert" : "Muss nicht signiert werden";

  if (read && !disabled) {
    readText = documentViewStatus.viewed_at
      ? `Hat am ${convertToDateTimeString(documentViewStatus.viewed_at)} das Dokument angeschaut`
      : "Hat das Dokument noch nicht angeschaut";
  }

  if (sign && !disabled) {
    signText = documentViewStatus.signed_at
      ? `Hat am ${convertToDateTimeString(documentViewStatus.signed_at)} das Dokument signiert`
      : "Hat das Dokument noch nicht signiert";
  }

  return (
    <Group gap="0" flex={flex} align="center" justify="center" wrap="nowrap">
      <Status display={read} disabled={disabled} ok={!!documentViewStatus.viewed_at} hoverCardText={readText} />
      <Status display={sign} disabled={disabled} ok={!!documentViewStatus.signed_at} hoverCardText={signText} />
    </Group>
  );
}

type StatusProps = {
  display: boolean;
  ok: boolean;
  hoverCardText: string;
  disabled?: boolean;
};

function Status({ display, ok, hoverCardText, disabled = false }: StatusProps) {
  const defaultColor = disabled ? "gray.8" : "lightgrey";
  return (
    <HoverCard>
      <HoverCard.Target>
        {display && !disabled ? (
          ok ? (
            <ThemeIcon p={0} variant="transparent" size="sm" color="zli-green">
              <IconCircleCheckFilled />
            </ThemeIcon>
          ) : (
            <ThemeIcon p={0} variant="transparent" size="sm" color="red">
              <IconCircleXFilled />
            </ThemeIcon>
          )
        ) : (
          <ThemeIcon p={0} variant="transparent" size="sm" color={defaultColor}>
            <IconCircleFilled />
          </ThemeIcon>
        )}
      </HoverCard.Target>
      <HoverCard.Dropdown>
        <Text>{hoverCardText}</Text>
      </HoverCard.Dropdown>
    </HoverCard>
  );
}
